import * as React from 'react';
// @ts-expect-error
import {components, ValueContainerProps} from 'react-select';

import {Button} from '../button/button';

/*
 * Component to truncate the number of items displayed in the select component.
 * This component can be used as a ValueContainer in react-select components.
 *
 * It will show only a limited number of selected values and display a button
 * to expand/collapse the full list.
 */
export const TruncatedValueContainer = ({
    children,
    maxItems,
    ...restProps
}: ValueContainerProps & {
    maxItems?: number;
}) => {
    const [showAll, setShowAll] = React.useState(false);

    // Convert children to an array
    const childrenArray = React.Children.toArray(children);
    // Pop the last child, the input element
    const inputElementChild = childrenArray.pop();

    // Determine truncate threshold: prefer provided maxItems, else read from selectProps, else default to 3
    const truncateAfter =
        maxItems ||
        (restProps && restProps.selectProps && typeof restProps.selectProps.maxItems === 'number'
            ? restProps.selectProps.maxItems
            : 3);

    let displayValues = children;

    if (childrenArray.length > truncateAfter) {
        const truncatedOptions = childrenArray.slice(0, truncateAfter);
        displayValues = (
            <>
                {showAll ? childrenArray : truncatedOptions}
                {inputElementChild}
                <Button
                    variant='text'
                    size='small'
                    // @ts-expect-error
                    onClick={() => setShowAll((prev) => !prev)}
                    // The search input toggles onMouseDown, so we need to
                    // prevent propagation here instead of within the onClick
                    // handler
                    // @ts-expect-error
                    onMouseDown={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                    }}
                    noPadding={true}
                >
                    {showAll ? 'See less' : `+${childrenArray.length - truncateAfter} more`}
                </Button>
            </>
        );
    }

    return <components.ValueContainer {...restProps}>{displayValues}</components.ValueContainer>;
};
